import Vue from 'vue';

var options = {
  persist: true,
};
Vue.use(options);
const state = {
  newTab800: '',
};

const getters = {
  getNewTab800: (state) => {
    return state.newTab800;
  },
};

const mutations = {
  set_NewTab800(state, text) {
    state.newTab800 = text;
  },
};

const actions = {
  setNewTabMap800({ commit }, text) {
    commit('set_NewTab800', text);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};